module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/save-2003ce5719e3e880618d2f866ea23079.svg";